import { useQuery } from "@apollo/client/react";import { Grid } from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { RenderInputsRowByType } from "../../../components/formGroupGenerator/RenderInputRowByType";
import { GroupedContainer } from "../../ContratosCreation/components/GroupedContainer";
import { useEnvioCreationContentForm } from "../hooks/useEnvioCreationContentForm";
import { ENVIO_ESTADO_AUTORIZADO_ID, useEnvioCreationContentInputs } from "../hooks/useEnvioCreationContentInputs";
import { useIndicacionSectionColumns } from "../hooks/useIndicacionSectionColumns";
import { useIndicacionSolicitudSectionColumns } from "../hooks/useIndicacionSolicitudSectionColumns";
import { CustomSection } from "./CustomSection";
import { EnvioActionsButtons } from "./EnvioActionsButtons";
import { ContratoSection } from "./sections/ContratoSection";
import { EnvioSection } from "./sections/EnvioSection";
import { InsumoSection } from "./sections/InsumoSection";
import { GET_DEPOSITOS_BY_ID_EVALUACION } from "../../../data/graphQL/queries/GestionAsistencial/getDepositosByIdEvaluacion";

import { useGetEnvioAnnouncement } from "../hooks/useGetEnvioAnnouncement";
import { TagWarningInfo } from "./TagWarningInfo";

export const ID_RESULTADO_CONDICIONAL = 2;

export function EnvioCreationContent({ setChildrenAction }) {
  const location = useLocation();
  const { datosDetalle, isNew, idEvaluacion, idOrdenPedido } = location.state || {};
  const { allowedWrite, fromScreen, tieneSuspensionObito } = datosDetalle || {};

  const {
    initialEnvioEstado,
    formValues,
    bloqueoClienteSAP,
    showJustificacionCondicional,
    showBum,
    handleChange,
    insumosRows,
    setInsumosRows,
    data,
    loading,
    isActualizarStockRequired,
    setIsActualizarStockRequired,
    // handleBlur
  } = useEnvioCreationContentForm({
    idEvaluacion,
    idOrdenPedido,
    isNew
  });

  const disabledNormalInput = useMemo(() => initialEnvioEstado === ENVIO_ESTADO_AUTORIZADO_ID || !allowedWrite, [initialEnvioEstado, allowedWrite]);

  const indicacionColumns = useIndicacionSectionColumns();
  const indicacionSolicitudColumns = useIndicacionSolicitudSectionColumns();

  const {
    envioAnnouncement
  } = useGetEnvioAnnouncement(
    formValues.complejidadPlan,
    formValues.idResultadoPresupuesto,
    formValues.diasCO,
    formValues.diasFacturacion,
    idEvaluacion,
    formValues.paciente,
    formValues.contratosCo
  );

  const {
    inputsEnvio,
    inputsDireccion,
    inputsDetalleIndicacion,
    inputsDetalleIndicacionSolicitud,
    inputsJustificacionCondicional
  } = useEnvioCreationContentInputs({
    idEvaluacion,
    isNew,
    estadoValue: initialEnvioEstado,
    allowedWrite,
    disabledNormalInput,
    enterFromScreen: fromScreen,
    tieneSuspensionObito: tieneSuspensionObito || data?.envio?.cabecera?.tieneSuspensionObito
  });

  const { data: depositos } = useQuery(GET_DEPOSITOS_BY_ID_EVALUACION, {
    fetchPolicy: "cache-first",
    variables: {
      idEvaluacion
    }
  });

  const addBlur = useMemo(() => {
    if (inputsEnvio) {
      const nodoDias = inputsEnvio.filter((p) => p.name === "diasPedido")[0];
      if (nodoDias != null) {
        // nodoDias.onBlur = handleBlur;
      }
    }
  }, [inputsEnvio]);


  const [centroSAP, almacenSAP] = useMemo(() => {
    const deposito = depositos?.depositosByIdEvaluacion?.find(
      (dep) => dep.idDeposito === formValues.idDeposito
    );
    return [deposito?.centroSAP, deposito?.almacenSAP];
  }, [formValues.idDeposito, depositos]);

  useEffect(() => {
    setChildrenAction(() =>
    <EnvioActionsButtons
      idOrdenPedido={idOrdenPedido}
      idEvaluacion={idEvaluacion}
      formValues={formValues}
      insumosRows={insumosRows}
      isActualizarStockRequired={isActualizarStockRequired}
      datosDetalle={datosDetalle}
      showBum={showBum}
      showJustificacionCondicional={showJustificacionCondicional}
      bloqueoClienteSAP={bloqueoClienteSAP}
      initialEnvioEstado={initialEnvioEstado} />

    );
  }, [formValues, insumosRows]);

  return (
    <>
      <EnvioSection
        announcement={envioAnnouncement}
        formValues={formValues}
        handleChange={handleChange}
        inputs={inputsEnvio}
        bloqueoClienteSAP={bloqueoClienteSAP} />
      
      {!isNew && showJustificacionCondicional &&
      <CustomSection title="Justificación condicional" collapsable>
          {inputsJustificacionCondicional.map((just) =>
        (just.name !== "Justificación BUM" || just.name === "Justificación BUM" && showBum) &&
        <GroupedContainer sectionTitle={just.name} key={just.name}>
                {just.rows.map((input, index) =>
          <RenderInputsRowByType
            key={`name-${input.name}-index${index}`}
            input={input}
            value={formValues[input.name]}
            handleChange={handleChange} />


          )}
              </GroupedContainer>

        )}
        </CustomSection>
      }

      <CustomSection title="Dirección">
        <Grid container columnSpacing={3} rowSpacing={3} columns={100}>
          {inputsDireccion.map((input, index) =>
          <RenderInputsRowByType
            key={`name-${input.name}-index${index}`}
            input={input}
            value={formValues[input.name]}
            handleChange={handleChange} />

          )}
        </Grid>
      </CustomSection>

      <ContratoSection
        formValues={formValues}
        idEvaluacion={idEvaluacion}
        data={data} />
      

      {/* indicaciones */}
      {
      formValues.indicaciones.map((indicacion) => {
        return (
          <CustomSection title="Detalle de indicación" collapsable>
              <Grid container columnSpacing={3} rowSpacing={3} columns={100}>
                {inputsDetalleIndicacion.map((input, index) =>
              <RenderInputsRowByType
                key={`name-${input.name}-index${index}`}
                input={input}
                value={indicacion[input.name]}
                handleChange={handleChange} />

              )}
              </Grid>
              <DataGridGenerico
              columns={indicacionColumns}
              rows={indicacion?.insumos}
              loading={loading}
              toolbar={false}
              localeText={{ noRowsLabel: "No posee indicaciones" }} />
            
            </CustomSection>);

      })
      }

      {
      data?.envio?.solicitudIndicacion != null &&
      data?.envio?.solicitudIndicacion?.insumos?.length > 0 &&
      <CustomSection title="Detalle de solicitud de cambio de indicación" collapsable>
          <Grid container columnSpacing={3}>
            <Grid size={{ xs: 12, md: 12, lg: 12 }}>
              <div style={{ paddingBottom: '5px' }}>
                <TagWarningInfo text="Los insumos de esta solicitud no se encuentran listados en la sección 'Detalle de insumo' ya que la solicitud se encuentra pendiente."></TagWarningInfo>
              </div>
            </Grid>
          </Grid>
          <Grid container columnSpacing={3} rowSpacing={3} columns={100}>
            {inputsDetalleIndicacionSolicitud.map((input, index) =>
          <RenderInputsRowByType
            key={`name-${input.name}-index${index}`}
            input={input}
            value={formValues[input.name]}
            handleChange={handleChange} />

          )}
          </Grid>
          <DataGridGenerico
          columns={indicacionSolicitudColumns}
          rows={data?.envio?.solicitudIndicacion?.insumos}
          loading={loading}
          toolbar={false}
          hideFooter
          localeText={{ noRowsLabel: "No posee solicitudes de cambio de indicación" }} />
        
        </CustomSection>
      }

      <InsumoSection
        insumosRows={insumosRows}
        disabledNormalInput={disabledNormalInput}
        initialEnvioEstado={initialEnvioEstado}
        setInsumosRows={setInsumosRows}
        data={data}
        loading={loading}
        idEvaluacion={idEvaluacion}
        isActualizarStockRequired={isActualizarStockRequired}
        setIsActualizarStockRequired={setIsActualizarStockRequired}
        centroSAP={centroSAP}
        almacenSAP={almacenSAP} />
      
    </>);

}